(function (root) {
  'use strict';

  function resolveCountryAllowlist(authoritative, fallback) {
    var primary = String(authoritative == null ? '' : authoritative).trim();
    if (primary) {
      return primary;
    }
    return String(fallback == null ? '' : fallback).trim();
  }

  function parseCountryAllowlist(raw) {
    if (raw == null || raw === '') {
      return [];
    }

    return String(raw)
      .split(',')
      .map(function (code) {
        return code.trim().toUpperCase();
      })
      .filter(function (code) {
        return code !== '';
      });
  }

  function isCountryEligible(allowlistRaw, countryCode) {
    if (countryCode == null || String(countryCode).trim() === '') {
      return false;
    }

    var current = String(countryCode).trim().toUpperCase();
    var codes = parseCountryAllowlist(allowlistRaw);

    for (var i = 0; i < codes.length; i++) {
      if (codes[i] === current) {
        return true;
      }
    }

    return false;
  }

  function applyQuickBuyPrivateSalePrices(productData, context) {
    context = context || {};

    if (!isCountryEligible(context.countryAllowlist, context.countryCode)) {
      return productData;
    }

    var productTags = productData.tags || [];

    if (context.customerIsLogged) {
      var customerTags = context.customerTags || [];
      var privateSaleCustomerTags = customerTags.filter(function (tag) {
        return String(tag).indexOf('PRIVATE_SALE') !== -1;
      });
      var productPrivateSaleTag = productTags.filter(function (tag) {
        return privateSaleCustomerTags.indexOf(tag) !== -1;
      });
      var vipSetting = context.vipDiscountsSetting || '';

      if (productPrivateSaleTag.length > 0 && vipSetting.indexOf(productPrivateSaleTag[0]) !== -1) {
        var privateSalePercent = Number(productPrivateSaleTag[0].split('_').pop());
        var privateSaleDisc = (productData.price * privateSalePercent) / 100;
        productData.discount_price = productData.price - privateSaleDisc;
      }
    }

    var prefix = context.privateSaleDiscountPrefix;
    var productsTag = context.privateSaleProductsTag;
    if (
      !context.isPrivateSalesCustomer ||
      !prefix ||
      !productsTag ||
      productTags.indexOf(productsTag) === -1
    ) {
      return productData;
    }

    var fullPrice = productData.price;
    productTags.forEach(function (prodTag) {
      if (String(prodTag).indexOf(prefix) !== -1) {
        var privatePercent = prodTag.split(':')[1];
        var privateDisc = (fullPrice * privatePercent) / 100;
        var privateDiscountCalc2 = privateDisc % 100;
        if (privateDiscountCalc2 != 0) {
          var privateDiscountCalc3 = 100 - privateDiscountCalc2;
          privateDisc = privateDisc + privateDiscountCalc3;
        }

        productData.price = fullPrice - privateDisc;
        productData.compare_at_price = fullPrice;
      }
    });

    return productData;
  }

  var api = {
    resolveCountryAllowlist: resolveCountryAllowlist,
    parseCountryAllowlist: parseCountryAllowlist,
    isCountryEligible: isCountryEligible,
    applyQuickBuyPrivateSalePrices: applyQuickBuyPrivateSalePrices
  };

  root.PrivateSaleEligibility = api;

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this);
